'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RequiredOnboarding = function RequiredOnboarding() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes2.default.REQUIRED_ONBOARDING_RECEIVED:
      return _extends({}, state, payload);

    default:
      return state;
  }
};

exports.default = RequiredOnboarding;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/RequiredOnboarding.js
// module id = 391
// module chunks = 3 4 5